//
import { gql } from '@apollo/client';
import { graphql } from 'graphql/client';
import { loadData, mutateData, queryData } from 'app/utils/redux/action-utils';
import loadPinDetailsQuery from 'graphql/maps/loadPinDetailsQuery';
import loadPinRelationshipsQuery from 'graphql/maps/loadPinRelationshipsQuery';
import loadMapDetailQuery from 'graphql/maps/loadMapDetailQuery';
import loadEntityLayerPinsQuery from 'graphql/maps/loadEntityLayerPinsQuery';
import loadEntitiesForRelationshipsQuery from 'graphql/maps/loadEntitiesForRelationshipsQuery';
import loadClassDefinitionQuery from 'graphql/maps/loadClassDefinitionQuery';
import entityLocationHistoryQuery from 'graphql/maps/entityLocationHistoryQuery';
import tasksQuery from 'graphql/abox/task/tasksQuery';
import loadProcessesQuery from 'graphql/maps/loadProcessesQuery';
import deleteEntity3dModelMutation from '/graphql/maps/deleteEntity3dModelMutation';
import deleteClass3dModelMutation from '/graphql/maps/deleteClass3dModelMutation';
import { transform } from 'ol/proj.js';
import greenlet from 'greenlet';
import { enrichContext } from 'app/utils/designer/form/formUtils';
import { __getMapLayers, BASELAYER_PRIMARY_KEY, getLayersAndStyles, LAYERS_PRIMARY_KEY, normalizeTasksProcessesLegacyMapLayers } from 'app/utils/maps/layer/layerUtils';
import { addRoleToData } from 'app/config/rolesConfig';
import updateEntityMutation from 'graphql/entities/entities/updateEntityMutation';
import { get } from 'app/utils/lo/lo';
import eventsQuery from 'graphql/maps/loadMapsEventsQuery';
import loadEntityQuery from 'graphql/entities/entities/loadEntityQuery';
import cesiumLayerConfig from 'app/config/cesiumLayerConfig';
import Immutable from 'app/utils/immutable/Immutable';
import { classDetailsFields } from 'graphql/entities/classifications/classificationDetailQuery';
import { isBoolean } from 'app/utils/utils';
import { fetchMapRelations } from 'store/actions/entities/relationshipsActions';
import { isValidGltf, modifyGeoserverUrl } from 'app/utils/maps/layer/layerUtils';
import { LOAD_CLASSIFICATION_STARTED, LOAD_CLASSIFICATION } from 'store/actions/classifications/classificationsActions.js';
import { workspaceFields } from 'graphql/entities/entities/loadEntityWorkspacesQuery';
import { set } from 'app/utils/immutable/Immutable';
import { typeMap } from 'app/config/typesConfig';
import entityDetailsQuery from 'graphql/maps/entityDetailsQuery';
import generateMultipleEntityDetailsQuery from 'graphql/maps/generateMultipleEntityDetailsQuery';

export const ADD_FEATURE_TO_HISTORY = '@@affectli/maps/ADD_FEATURE_TO_HISTORY';
export const REMOVE_FEATURE_FROM_HISTORY = '@@affectli/maps/REMOVE_FEATURE_FROM_HISTORY';
export const SET_STROKE_WIDTH = '@@affectli/maps/SET_STROKE_WIDTH';
export const SET_STROKE_COLOR = '@@affectli/maps/SET_STROKE_COLOR';
export const PIN_DETAILS_STARETD = '@@affectli/maps/PIN_DETAILS_STARETD';
export const PIN_DETAILS = '@@affectli/maps/PIN_DETAILS';
export const PIN_ATTACHMENTS_STARETD = '@@affectli/maps/PIN_ATTACHMENTS_STARETD';
export const PIN_ATTACHMENTS = '@@affectli/maps/PIN_ATTACHMENTS';
export const PIN_RELATIONSHIPS_STARETD = '@@affectli/maps/PIN_RELATIONSHIPS_STARETD';
export const PIN_RELATIONSHIPS = '@@affectli/maps/PIN_RELATIONSHIPS';
export const RESET_MAP_DATA = '@@affectli/maps/RESET_MAP_DATA';
export const ADD_NEW_LAYER = '@@affectli/maps/ADD_NEW_LAYER';
export const UPDATE_MAP_LAYER = '@@affectli/maps/UPDATE_MAP_LAYER';
export const UPDATE_MAP_LAYERS = '@@affectli/maps/UPDATE_MAP_LAYERS';
export const REMOVE_LAYER = '@@affectli/maps/REMOVE_LAYER';
export const TOGGLE_LAYER_FLITERS = '@@affectli/maps/TOGGLE_LAYER_FLITERS';
export const RESET_ALL_LAYERS = '@@affectli/maps/RESET_ALL_LAYERS';
export const DISABLE_MAP_SEARCH = '@@affectli/maps/DISABLE_MAP_SEARCH';
export const ENABLE_MAP_SEARCH = '@@affectli/maps/ENABLE_MAP_SEARCH';
export const LOAD_MAP_LAYER_FILTERS_MENU = '@@affectli/maps/LOAD_MAP_LAYER_FILTERS_MENU';
export const SET_LAYER_TYPES = '@@affectli/maps/SET_LAYER_TYPES';
export const LOAD_MAP_DATA_STARTED = '@@affectli/maps/LOAD_MAP_DATA_STARTED';
export const LOAD_MAP_DATA = '@@affectli/maps/LOAD_MAP_DATA';
export const SET_SELECTED_LAYER = '@@affectli/maps/SET_SELECTED_LAYER';
export const SET_MAP_HAS_DRAWING = '@@affectli/maps/SET_MAP_HAS_DRAWING';
export const UPDATE_LAYER_ATTRIBUTE = '@@affectli/maps/UPDATE_LAYER_ATTRIBUTE';
export const UPDATE_BASE_LAYER = '@@affectli/maps/UPDATE_BASE_LAYER';
export const TOGGLE_FULLSCREEN_MAP = '@@affectli/maps/TOGGLE_FULLSCREEN_MAP';
export const REFRESH_MAP_SIDEBAR_LAYERS = '@@affectli/maps/REFRESH_MAP_SIDEBAR_LAYERS';
export const REFRESH_MAP_LAYERS_DRAWER = '@@affectli/maps/REFRESH_MAP_LAYERS_DRAWER';
export const UPLOAD_3D_MODEL_FILE_STARTED = '@@affectli/entities/UPLOAD_3D_MODEL_FILE_STARTED';
export const UPLOAD_3D_MODEL_FILE = '@@affectli/entities/UPLOAD_3D_MODEL';
export const UPLOAD_GEOMETRY_FILE_STARTED = '@@affectli/maps/UPLOAD_GEOMETRY_FILE_STARTED';
export const UPLOAD_GEOMETRY_FILE = '@@affectli/maps/UPLOAD_GEOMETRY_FILE';
export const SET_ADD_PIN_MODAL = '@@affectli/maps/SET_ADD_PIN_MODAL';
export const DELETE_3D_FILE_STARTED = '@@affectli/maps/DELETE_3D_FILE_STARTED';
export const DELETE_3D_FILE = '@@affectli/maps/DELETE_3D_FILE';
export const ENABLE_RELATION_COUNTER = '@@affectli/maps/ENABLE_RELATION_COUNTER';
export const DISABLE_RELATION_COUNTER = '@@affectli/maps/DISABLE_RELATION_COUNTER';
export const TOGGLE_ADD_PIN_BUTTON = '@@affectli/maps/TOGGLE_ADD_PIN_BUTTON';
export const SET_LAYER_LOADING = '@@affectli/maps/SET_LAYER_LOADING';
export const SET_ALL_LIST_ITEM_LOADING = '@@affectli/maps/SET_ALL_LIST_ITEM_LOADING';
export const SET_LAYER_ENTITIES_HIDDEN = '@@affectli/maps/SET_LAYER_ENTITIES_HIDDEN';
export const SAVE_LAYER_FEATURES = '@@affectli/maps/SAVE_LAYER_FEATURES';
export const SHOW_REPLAY_LAYER_COMPONENT = 'SHOW_REPLAY_LAYER_COMPONENT';
export const SET_REPLAY_LAYER_RESTART = '@@affectli/maps/SET_REPLAY_LAYER_RESTART';
export const TRIGGER_REPLAY_LAYER_REFRESH = '@@affectli/maps/TRIGGER_REPLAY_LAYER_REFRESH';
export const LOAD_MAP_PROJECTIONS_LIST_STARTED = '@@affectli/maps/LOAD_MAP_PROJECTIONS_LIST_STARTED';
export const LOAD_MAP_PROJECTIONS_LIST = '@@affectli/maps/LOAD_MAP_PROJECTIONS_LIST';

export const triggerReplayLayerRefresh = () => ({
    type: TRIGGER_REPLAY_LAYER_REFRESH,
    payload: Date.now(), 
});

export const setReplayLayerRestart = (layerId, shouldRestart) => ({
    type: SET_REPLAY_LAYER_RESTART,
    payload: { layerId, shouldRestart }
});

export const loadMultipleEntities = (entities) => async (dispatch) => {
    if (!entities || !entities.length) {
        return Promise.resolve({});
    }
  
    try {
        const query = generateMultipleEntityDetailsQuery(entities.length);
        const variables = {};
      
        entities.forEach((entity, index) => {
            variables[`type${index}`] = entity.type;
            variables[`id${index}`] = entity.id;
        });
      
        const response = await queryData(query, variables, 1000);
        const data = response?.data;
      
        if (data) {
            const resultsArray = Object.keys(data)
                .filter(key => key.startsWith('entity'))
                .sort((a, b) => {
                    const numA = parseInt(a.replace('entity', ''));
                    const numB = parseInt(b.replace('entity', ''));
                    return numA - numB;
                })
                .map(key => data[key]);
                
            return resultsArray;
        }
  
        return [];
    } catch (error) {
      
        console.error('Error loading multiple entities:', error);
        return error;
    }
};

export const loadReplayEntityData = async (type, id) => {
    try {
        const data = await queryData(entityDetailsQuery, { type, id });
        return data?.data?.entity || null;
    } catch (error) {
        console.error('Error fetching entity data:', error);
        return null;
    }
};

export const loadEntitiesPins = (type, variables = {}, fields) => {
    return queryData(loadEntityLayerPinsQuery(type, fields), variables);
};

export const loadTasks = (variables = []) => {
    return queryData(tasksQuery, variables);
};

export const loadProcesses = (variables = []) => {
    return queryData(loadProcessesQuery, variables);
};

export const loadEventLayerPins = (variables = {}) => {
    return queryData(eventsQuery, variables);
};

export const loadEntitiesRelationsPins = (variables = {}) => {
    return queryData(loadEntitiesForRelationshipsQuery, variables);
};

export const loadClassFormDefinition = id => queryData(loadClassDefinitionQuery, { id });

const to4326 = coordinate => {
    return transform([parseFloat(coordinate[0]), parseFloat(coordinate[1])], 'EPSG:3857', 'EPSG:4326');
};

export const getGeoserverInfo = async url => {
    try {
        const updatedUrl = modifyGeoserverUrl(url);
        if (updatedUrl) {
            const response = await fetch(updatedUrl);
            if (response.ok) {
                const text = await response.text();
                const parser = new DOMParser();
                const xmlData = parser.parseFromString(text, 'application/xml');
                const data = getLayersAndStyles(xmlData);
                return data;
            } else {
                return { status: response.status, msg: response.statusText }; // Return status and error message
            }
        } else {
            throw new Error('Please enter a valid url.');
        }
    } catch (error) {
        return { msg: error.message };
    }
};

export const getAddressFromCoords = coords => {
    return fetch('http://nominatim.openstreetmap.org/reverse?format=json&lon=' + coords[0] + '&lat=' + coords[1]).then(response => response.json());
};

export const getNearest = coordinate => {
    const coord4326 = to4326(coordinate);
    return new Promise((resolve, reject) => {
        //make sure the coord is on street
        const response = fetch(`//router.project-osrm.org/nearest/v1/driving/${coord4326.join()}`);
        response
            .then(response => response.json())
            .then(json => {
                if (json.code === 'Ok') resolve(json.waypoints[0].location);
                else reject();
            });
        response.catch(() => reject());
    });
};

export const getRoute = (start, end) => {
    return fetch(`//router.project-osrm.org/route/v1/driving/${start};${end}`);
};

export const loadPinDetails = (type, id) => {
    if (type) {
        id = String(id);
    }
    const variables = { id };
    return loadData(PIN_DETAILS_STARETD, PIN_DETAILS, loadPinDetailsQuery(type))(variables);
};

export const loadPinRelationships = (entityType, entityId) => {
    const variables = { entityType, entityId, startIndex: 0, stopIndex: 10 };
    return loadData(PIN_RELATIONSHIPS_STARETD, PIN_RELATIONSHIPS, loadPinRelationshipsQuery)(variables);
};

export const updateLayerAttribute = (layer, keyToUpdate, value = 'toggleValue') => (dispatch, getState) => {
    const { id, name, title } = layer || {};
    try {
        const mapData = getState().maps.situationalAwareness.map.data;
        if (!mapData) return;
        const layers = __getMapLayers(mapData);
        if (!layers?.length) return;
        let updatedLayer = {};
        const updatedLayers = layers.map(lyr => {
            if (lyr?.id === id || lyr?.name === name || lyr?.name === title) {
                updatedLayer = set(lyr, keyToUpdate, value === 'toggleValue' ? !lyr[keyToUpdate] : value);
                return updatedLayer;
            }
            return { ...lyr };
        });
        dispatch({ type: UPDATE_LAYER_ATTRIBUTE, payload: updatedLayers });
        return updatedLayer;
    } catch (error) {
        console.error('Maps: Error while updating layer attribute ', error); // eslint-disable-line
    }
};

export const updateBaseLayer = title => (dispatch, getState) => {
    dispatch({ type: UPDATE_BASE_LAYER, payload: title });
};

export const setMapHasDrawing = hasDrawing => dispatch => {
    dispatch({ type: SET_MAP_HAS_DRAWING, payload: hasDrawing });
};

export const setSelectedLayer = layer => dispatch => {
    const payload = layer === null ? {} : layer;
    dispatch({ type: SET_SELECTED_LAYER, payload });
};

export const setStrokeColor = strokeColor => dispatch => {
    dispatch({ type: SET_STROKE_COLOR, payload: strokeColor });
};

export const addFeaturesToHistory = feature => dispatch => {
    dispatch({ type: ADD_FEATURE_TO_HISTORY, payload: feature });
};

export const removeFeaturesFromHistory = () => dispatch => {
    dispatch({ type: REMOVE_FEATURE_FROM_HISTORY });
};

export const setStrokeWidth = feature => dispatch => {
    dispatch({ type: SET_STROKE_WIDTH, payload: feature });
};

export const resetAllLayers = () => dispatch => {
    dispatch({ type: RESET_ALL_LAYERS });
};

export const toggleLayerFilter = layer => dispatch => {
    dispatch({ type: TOGGLE_LAYER_FLITERS, payload: layer });
};

export const toggleFullScreenMap = value => dispatch => {
    dispatch({ type: TOGGLE_FULLSCREEN_MAP, payload: value });
};

export const layerService = (serviceDefinition, options) => {
    return greenlet(`(context, options) => {
        context.graphql = eval(context.graphql);
        try {
          return (${serviceDefinition})(context, options);
        } catch(e) {
          console.error('an error occured executing the user defined map service function', ${serviceDefinition}, e);
          throw new Error('an error occured executing the user defined map service function.');
        }
    }`)(enrichContext(), options);
};

export const getLayerFiltersMenu = ({ title, filtersMenuDefinition, options = {} }) => dispatch => {
    greenlet(`(context, options) => {
        context.graphql = eval(context.graphql);
        try {
          return (${filtersMenuDefinition})(context, options);
        } catch(e) {
          console.error('an error occured executing the user defined map service function', ${filtersMenuDefinition}, e);
          throw new Error('an error occured executing the user defined map service function.');
        }
    }`)(enrichContext(), options).then(data => {
        dispatch(loadLayerFiltersMenu({ title, data }));
    });
};

export const loadLayerFiltersMenu = ({ title, data }) => dispatch => {
    dispatch({ type: LOAD_MAP_LAYER_FILTERS_MENU, payload: { title, data } });
};

export const toggleMapSearch = isDisabled => dispatch => {
    if (isDisabled) {
        dispatch(disableMapSearch());
    } else {
        dispatch(enableMapSearch());
    }
};

export const enableMapSearch = () => dispatch => {
    dispatch({ type: ENABLE_MAP_SEARCH });
};

export const disableMapSearch = () => dispatch => {
    dispatch({ type: DISABLE_MAP_SEARCH });
};

export const resetMapData = () => dispatch => {
    dispatch({ type: RESET_MAP_DATA });
};

export const addNewLayer = layer => dispatch => {
    dispatch({ type: ADD_NEW_LAYER, payload: layer });
};

export const updateMapLayer = layer => dispatch => {
    dispatch({ type: UPDATE_MAP_LAYER, payload: layer });
};

export const removeLayer = layer => dispatch => {
    dispatch({ type: REMOVE_LAYER, payload: layer });
};

export const loadMapData = (id, type) => (dispatch, getState) =>{
    return loadData(LOAD_MAP_DATA_STARTED, LOAD_MAP_DATA, loadMapDetailQuery, (payload) => {
        const layers = __getMapLayers(payload);
        const primaryClasses = getState().app.allPrimaryClasses.records || [];
        const { defaultMapBaseLayer } = getState().app.mapSettings || {};
        const selectedBaseLayer = get(payload, BASELAYER_PRIMARY_KEY)
        if(!selectedBaseLayer && defaultMapBaseLayer) { // if default map base layer is set and no base layer is selected then set the default map base layer from site map settings
            payload = set(payload, BASELAYER_PRIMARY_KEY, defaultMapBaseLayer);
        }
        const normalizedLayers = layers?.map(layer => ({ ...normalizeTasksProcessesLegacyMapLayers(layer, primaryClasses) }));
        const data = set(payload, LAYERS_PRIMARY_KEY, normalizedLayers);
        return addRoleToData(data)
    })({ id, type })(dispatch, getState);
};

export const updateMapData = (payload, refreshCache = false) => {
    const { id } = payload;
    let record = { id, type: typeMap['map'] };
    const keysToCheck = ['name', 'primary', 'svgTransformation', 'description', 'active'];
    record = keysToCheck.reduce((acc, key) => {
        if (key in payload) {
            acc[key] = payload[key];
        }
        return acc;
    }, record);

    return mutateData(
        refreshCache ? LOAD_MAP_DATA_STARTED : '@@Maps/UPDATE_MAP_DATA_STARTED',
        refreshCache ? LOAD_MAP_DATA : '@@Maps/UPDATE_MAP_DATA',
        updateEntityMutation,
        'Map has been updated.',
        addRoleToData
    )({ record });
};

export const updateMapLayers = layers => dispatch => {
    dispatch({ type: UPDATE_MAP_LAYERS, payload: layers });
};

export const refreshMapSideBarLayers = value => dispatch => {
    dispatch({ type: REFRESH_MAP_SIDEBAR_LAYERS, payload: value });
};

export const loadEntityLocationHistory = variables => {
    return queryData(entityLocationHistoryQuery, variables);
};

export const loadMapProjectionsList = () => async (dispatch) => {
    try {
        dispatch({ type: LOAD_MAP_PROJECTIONS_LIST_STARTED });
        
        // Fetch projections data from static JSON file
        const response = await fetch('/data/projections.json');

        if (!response.ok) { 
            dispatch({ type: LOAD_MAP_PROJECTIONS_LIST, error: true });
        }

        const projections = await response.json();
        
        dispatch({ 
            type: LOAD_MAP_PROJECTIONS_LIST, 
            payload: projections 
        });
        
        return projections;
    } catch (error) {
        console.error('Failed to load projections:', error);
        dispatch({ 
            type: LOAD_MAP_PROJECTIONS_LIST, 
            error: true,
            payload: error.message || 'Failed to load projections'
        });
        throw error;
    }
};

export const loadEntityDetails = async (id, type) => {
    try {
        const data = await queryData(loadEntityQuery, { id, type });
        return data?.data?.result;
    } catch (error) {
        return {};
    }
};

export const refreshMapLayersDrawer = () => dispatch => {
    dispatch({ type: REFRESH_MAP_LAYERS_DRAWER });
};

export const loadEntity = async id => {
    const response = await graphql.query({
        query: gql`query loadCesiumTokenData($id: ID!) {
                result: entity(type: "${cesiumLayerConfig?.cesiumAccount?.type || cesiumLayerConfig?.cesiumAccount?.oldType}", id: $id) { id name }
            }`,
        variables: { id },
        fetchPolicy: 'no-cache',
    });
    if (!(response instanceof Error)) {
        return response;
    }
};

export const updateEntity3dModelMutation = data => {
    const { id, name, model, type, isClass } = data;
    const variables = { id, name, model3d: model, type };
    let query = '';
    if (isClass) {
        query = `mutation ($id: ID!, $model3d: Upload!) { result: updateClassEntity3dModel(id: $id, model3d: $model3d) { ${classDetailsFields} }}`;
    } else {
        query = 'mutation ($type: String!, $id: ID!, $model3d: Upload!) { result: updateEntity3dModel(type: $type, id: $id, model3d: $model3d) { id }}';
    }
    return graphql.upload({ query, variables, file: model, map: 'variables.model3d' });
};

export const updateEntity3dModel = (entityType, entityId, model, isClass = false) => async dispatch => {
    if (!entityId || !model) {
        throw new Error(`Cannot upload the model: a required parameter is missing: id=${entityId}, type=${entityType}, model=${String(model)}`);
    }
    const startAction = isClass ? LOAD_CLASSIFICATION_STARTED : UPLOAD_3D_MODEL_FILE_STARTED;
    const endAction = isClass ? LOAD_CLASSIFICATION : UPLOAD_3D_MODEL_FILE;
    const splittedArray = model?.name?.split('.');
    const modelExt = splittedArray[splittedArray.length - 1];

    const checkModel = await isValidGltf(model, modelExt);
    if (checkModel?.severity === 'error') {
        return dispatch({ type: endAction, payload: checkModel?.detail, error: true, meta: Immutable({ errorMessage: checkModel?.detail }) });
    }

    if (!['gltf', 'glb'].includes(modelExt)) {
        dispatch({
            type: UPLOAD_3D_MODEL_FILE,
            payload: new Error('Upload failed: the specified file is not a model.'),
            error: true,
            meta: Immutable({
                errorTitle: 'Uploading model failed',
                errorMessage: `The file "${model.name}" is not a model.`,
            }),
        });
        const error = new Error(`The file "${model.name}" is not a model.`);
        return Promise.reject(error);
    }

    dispatch({ type: startAction, meta: Immutable({ entityId, entityType }) });
    const data = { id: entityId, model, type: entityType, isClass };
    return updateEntity3dModelMutation(data)
        .then(async response => {
            const data = await addRoleToData({ ...(response?.data?.result || {}), type: 'class' });
            dispatch({
                type: endAction,
                payload: Immutable(data),
                meta: Immutable({ entityId, entityType, successMessage: 'Model uploaded.' }),
            });
        })
        .catch(error => {
            dispatch({ type: endAction, payload: error, error: true, meta: Immutable({ entityId, entityType, errorMessage: 'Model upload failed.' }) });
            return error;
        });
};

export const uploadGeometryFile = (type, id, file, srid) => dispatch => {
    dispatch({ type: UPLOAD_GEOMETRY_FILE_STARTED });
    const query = `
    mutation ($type: String!, $id: ID!, $file: Upload!, $srid: Int) {
      uploadEntityGeometry(type: $type, id: $id, file: $file, srid: $srid) { id }
    }`;
    const variables = { type, id, file: null, srid };
    return graphql
        .upload({ query, variables, file, map: 'variables.file' })
        .then(response => {
            dispatch({
                type: UPLOAD_GEOMETRY_FILE,
                payload: Immutable(response),
                meta: Immutable({ successMessage: 'Geometry updated.' }),
            });
            return response;
        })
        .catch(error => {
            dispatch({ type: UPLOAD_GEOMETRY_FILE, payload: error, error: true, meta: Immutable({ errorMessage: 'Geometry update failed.' }) });
        });
};

export const setAddPinModal = show => (dispatch, getState) => {
    const payload = typeof show === 'boolean' ? show : !getState().maps.situationalAwareness.layer.showAddPinModal;
    dispatch({ type: SET_ADD_PIN_MODAL, payload });
};

export const toggleAddPinBtn = (show, isErase = false) => (dispatch, getState) => {
    let payload;
    const existingValue = getState().maps.situationalAwareness.layer.showAddPinBtn;
    if (isBoolean(show)) {
        payload = show;
        if(payload === existingValue) return;
    } else {
        payload = !existingValue;
    }
    dispatch({ type: TOGGLE_ADD_PIN_BUTTON, payload });
    !payload && !isErase && dispatch(removeCreatePinInteraction()); // if add pin button is hidden and drawing layer is not selected with erase icon click then remove the cursor from maps
};

export const removeCreatePinInteraction = () => dispatch => {
    // It will reset the map cursor and hide the add pin modal
    dispatch(setAddPinModal(false));
    const mapDiv = document.getElementById('map');
    if (mapDiv) mapDiv.style.cursor = null;
};

export const deleteEntity3dModel = data => {
    const { id, type, isClass } = data;
    if (isClass) {
        return mutateData(LOAD_CLASSIFICATION_STARTED, LOAD_CLASSIFICATION, deleteClass3dModelMutation, '3D  model removed successfully', payload =>
            addRoleToData({ ...payload, type: 'class' })
        )({ id });
    }
    return mutateData(DELETE_3D_FILE_STARTED, DELETE_3D_FILE, deleteEntity3dModelMutation, '3D  model removed successfully')({ type, id });
};

export const enableRelationCunter = () => dispatch => {
    dispatch({ type: ENABLE_RELATION_COUNTER });
};

export const disableRelationCunter = () => dispatch => {
    dispatch({ type: DISABLE_RELATION_COUNTER });
};

export const shareMapLayers = async (mapId, shareToData, shareWith) => {
    const response = await fetchMapRelations({ entityType: 'map', entityId: mapId });
    if (response instanceof Error) return Promise.resolve();
    const { data } = response || {};
    const relations = get(data, 'relations', []);
    if (!relations.length) return Promise.resolve();
    let query = '';
    switch (shareWith) {
        case 'users':
            query = `mutation shareEntityWithUsersMutation($id: ID!, $shareToData: [UserMemberInput]!, $type: String!) {
                result: shareEntityWithUsers(id: $id, userMembers: $shareToData, type: $type) {
                    id
                    type
                }
            }`;
            break;
        case 'teams':
            query = `mutation shareEntityWithTeamsMutation($id: ID!, $shareToData: [TeamMemberInput]!, $type: String!) {
                result: shareEntityWithTeams(id: $id, teamMembers: $shareToData, type: $type) {
                    type
                    id
                }
            }`;
            break;
        case 'workspaces':
            query = `mutation shareEntityWithWorkspacesMutation($id: ID!, $shareToData: [ID]!, $type: String!) {
                result: shareEntityWithWorkspaces(id: $id, workspaces: $shareToData, type: $type) {
                    id
                    type
                }
            }`;
            break;
        default:
            break;
    }
    const promises = relations
        .map(lyr => {
            const { id, type } = lyr?.relatedEntity || {};
            if (id && type) {
                return graphql.query({
                    query: gql`
                        ${query}
                    `,
                    variables: { id, type, shareToData },
                    fetchPolicy: 'no-cache',
                });
            }
            return null;
        })
        .filter(Boolean);
    return Promise.all(promises);
};

export const unShareMapLayers = async (mapId, shareToData, shareWith) => {
    const response = await fetchMapRelations({ entityType: 'map', entityId: mapId });
    if (response instanceof Error) return Promise.resolve();
    const { data } = response || {};
    const relations = get(data, 'relations', []);
    if (!relations.length) return Promise.resolve();
    let query = '';
    switch (shareWith) {
        case 'users':
            query = `mutation unshareEntityWithUsersMutation($id: ID!, $shareToData: [ID]!, $type: String!) {
                result: unshareEntityWithUsers(id: $id, users: $shareToData, type: $type) {
                    ${workspaceFields}
                }
            }`;
            break;
        case 'teams':
            query = `mutation unshareEntityWithTeamsMutation($id: ID!, $shareToData: [ID]!, $type: String!) {
                result: unshareEntityWithTeams(id: $id, teams: $shareToData, type: $type) {
                  ${workspaceFields}
                }
            }`;
            break;
        case 'workspaces':
            query = `mutation unshareEntityWithWorkspacesMutation($id: ID!, $shareToData: [ID]!, $type: String!) {
                result: unshareEntityWithWorkspaces(id: $id, workspaces: $shareToData, type: $type) {
                  ${workspaceFields}
                }
            }`;
            break;
        default:
            break;
    }
    const promises = relations
        .map(lyr => {
            const { id, type } = lyr?.relatedEntity || {};
            if (id && type) {
                return graphql.query({
                    query: gql`
                        ${query}
                    `,
                    variables: { id, type, shareToData },
                    fetchPolicy: 'no-cache',
                });
            }
            return null;
        })
        .filter(Boolean);
    return Promise.all(promises);
};

export const setAllLayersLoading = () => dispatch => {
    dispatch({ type: SET_ALL_LIST_ITEM_LOADING });
};

export const setLayerLoading = id => dispatch => {
    if (!id) return;
    dispatch({ type: SET_LAYER_LOADING, payload: id });
};

export const setLayerEntitiesHidden = (id, status) => dispatch => {
    dispatch({ type: SET_LAYER_ENTITIES_HIDDEN, payload: { id, status } });
};

export const saveLayerFeatures = (id, features) => dispatch => {
    if (!id) return;
    dispatch({ type: SAVE_LAYER_FEATURES, payload: { id, features } });
};

export const enableReplayLayerComponent = payload => ({
    type: SHOW_REPLAY_LAYER_COMPONENT,
    payload,
});
